<template>
    <div>
        <div class="header">
            <div class="container-fluid">
                <div class="header-body">
                    <div class="row align-items-center">
                        <div class="col">
                            <h6 class="header-pretitle">{{$t('Appointments')}}</h6>
                            <h1 class="header-title">{{$t('Board')}}</h1>
                        </div>
                        <div class="col-auto">
                            <team-filter v-model="staff"></team-filter>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-content">
            <div
                class="tab-pane fade active show"
                id="kanbanColumns"
                role="tabpanel"
                aria-labelledby="kanbanColumnsToggle"
            >
                <div class="container-fluid kanban-container">
                    <div class="row">
                        <div class="col-12">
                            <!-- Card -->
                            <div class="card">
                                <div class="card-header card-header-flush">
                                    <div class="row align-items-center">
                                        <div class="col">
                                            <!-- Title -->
                                            <h4 class="card-header-title">{{ $t('Planned') }}</h4>
                                        </div>
                                    </div>
                                    <!-- / .row -->
                                </div>
                                <div class="card-body">
                                    <div class="kanban-category" tabindex="0">
                                        <div class="kanban-item" tabindex="0">
                                            <draggable
                                                group="appointments"
                                                :list="confirmed"
                                                @change="change($event, 'confirmed')"
                                            >
                                                <card
                                                    :appointment="appointment"
                                                    :view="view"
                                                    v-for="(appointment, index) in confirmed"
                                                    :key="index"
                                                ></card>
                                            </draggable>
                                            <div
                                                v-if="confirmed.length==0"
                                                class="card-body text-center small text-muted"
                                            >{{$t('No confirmed appointments')}}</div>
                                        </div>
                                    </div>

                                    <!-- Add -->
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <!-- Card -->
                            <div class="card">
                                <div class="card-header card-header-flush">
                                    <div class="row align-items-center">
                                        <div class="col">
                                            <!-- Title -->
                                            <h4 class="card-header-title">{{ $t('Arrived') }}</h4>
                                        </div>
                                    </div>
                                    <!-- / .row -->
                                </div>
                                <div class="card-body">
                                    <div class="kanban-category" tabindex="0">
                                        <div class="kanban-item" tabindex="0">
                                            <draggable
                                                group="appointments"
                                                :list="arrived"
                                                @change="change($event, 'arrived')"
                                            >
                                                <card
                                                    :appointment="appointment"
                                                    :view="view"
                                                    v-for="(appointment, index) in arrived"
                                                    :key="index"
                                                ></card>
                                            </draggable>
                                            <div
                                                v-if="arrived.length==0"
                                                class="card-body text-center small text-muted"
                                            >{{$t('No waiting appointments')}}</div>
                                        </div>
                                    </div>

                                    <!-- Add -->
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <!-- Card -->
                            <div class="card">
                                <div class="card-header card-header-flush">
                                    <div class="row align-items-center">
                                        <div class="col">
                                            <!-- Title -->
                                            <h4 class="card-header-title">{{ $t('Started') }}</h4>
                                        </div>
                                    </div>
                                    <!-- / .row -->
                                </div>
                                <div class="card-body">
                                    <div class="kanban-category" tabindex="0">
                                        <div class="kanban-item" tabindex="0">
                                            <draggable
                                                group="appointments"
                                                :list="started"
                                                @change="change($event, 'started')"
                                            >
                                                <card
                                                    :appointment="appointment"
                                                    :view="view"
                                                    v-for="(appointment, index) in started"
                                                    :key="index"
                                                ></card>
                                            </draggable>
                                            <div
                                                v-if="started.length==0"
                                                class="card-body text-center small text-muted"
                                            >{{$t('No waiting appointments')}}</div>
                                        </div>
                                    </div>

                                    <!-- Add -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- / .row -->
                </div>
            </div>
        </div>

        <appointment-view-modal id="AppointmentViewModal" :appointment="model"></appointment-view-modal>
        <customer-modal :customer="model" id="customerFormModal"></customer-modal>
    </div>
</template>

<script>
import Card from './Card.vue';
import draggable from 'vuedraggable'

import { modalMixins } from '@/mixins/modal.js'
import { mapActions, mapGetters, mapState } from 'vuex';
import CheckoutModal from '@/Pages/Sales/CheckoutModal.vue';
import CustomerModal from '@/Pages/People/CustomerModal.vue';
import AppointmentViewModal from '@/Pages/Appointments/ViewModal.vue';
import TeamFilter from "@/components/TeamFilter";


export default {
    components: {
        Card,
        draggable,
        CustomerModal,
        CheckoutModal,
        AppointmentViewModal,
        TeamFilter,
    },
    mixins: [modalMixins],
    data() {
        return {
            staff: [],
            params: {
                query: {
                    startAt: { $gte: this.$moment().startOf('day'), $lte: this.$moment().endOf('day') },
                    $sort: { startAt: 1 },
                },
            }

        }
    },
    watch: {
        staff(newVal) {

            if (newVal.length <= 0) {
                delete this.params.query.services;
            } else {
                this.params.query.services = { userId: { $in: newVal } };
            }
            this.fetchAppointments();
        },
    },
    computed: {
        ...mapState('appointment', { areDataLoading: 'isFindPending' }),
        ...mapGetters('appointment', { findDataInStore: 'find' }),
        ...mapState('my-team', { isTeamLoading: 'isFindPending' }),
        ...mapGetters('my-team', { findTeamInStore: 'find', user: 'get' }),
        ...mapGetters('customers', { getCustomer: 'get' }),
        ...mapState('treatment', { areTreatmentsLoading: 'isFindPending' }),
        ...mapGetters('treatment', { findTreatmentInStore: 'find', treatment: 'get' }),

        services() {
            return this.findServicesInStore({ query: { $sort: { priority: 1 } } }).data;
        },
        treatments() {
            return this.findTreatmentInStore().data;
        },
        confirmed() {
            return this.appointments(['confirmed', 'new', 'late', 'notConfirmed']);
        },
        started() {
            return this.appointments(['started']);
        },
        arrived() {
            return this.appointments(['arrived']);
        },
    },
    created() {
        this.fetchAppointments();
    },
    methods: {
        ...mapActions('appointment', ['find', 'patch']),
        ...mapActions('push-notifications', { createPush: 'create' }),
        // ...mapActions('treatment', { fetchTreatments: 'find' }),

        view(appointment) {
            this.openModal({ id: 'AppointmentViewModal', model: appointment });
        },
        appointments(status) {

            let items = this.findDataInStore({ query: { ...this.params.query, status: { $in: status } } }).data;

            items.map(item => {
                item.colors = [];
                item.services.map(service => {
                    service.user = this.user(service.userId);
                    if (service.user) {
                        item.colors.push(service.user.color);
                        item.colors = item.colors.filter((value, index, self) => self.indexOf(value) === index);
                    }
                    service.treatment = this.treatment(service.treatmentId);
                });
            })
            return items;
        },

        change: function (event, status) {
            if (!event.added) return;

            let item = event.added.element;
            this.patch([item._id, { status }]);

            if (status === 'arrived') {
                for (let i = 0; event.added.element.services.length > i; i++) {
                    let push = {
                        userId: event.added.element.services[i].userId,
                        options: {
                            name: event.added.element.customer.first_name + ' ' + event.added.element.customer.last_name,
                            phone: event.added.element.customer.phone,
                            birth_date: event.added.element.customer.birth_date,
                            duration: event.added.element.services[i].duration,
                            treatment: event.added.element.services[i].treatment['label'],
                            service: event.added.element.services[i].treatment['service'].label,
                            icon: event.added.element.customer.avatar.preview,
                        },
                    }
                    this.createPush(push)
                }

            }
        },

        fetchAppointments() {
            this.find(this.params).then(result => {
                let customers = result.data.map(item => item.customerId);
            });

        },
    }
}
</script>

<style>

</style>
